import { InjectionToken } from '@angular/core';
import { HeaderLink } from './interfaces/community-types';
import { Features } from './interfaces';
import { PartnerServices } from './interfaces/partner-services';
import { PartnerApp } from './interfaces/partner';
import { CommunityExternalApi } from './interfaces/api/external-api';
import { ConfigLink } from './interfaces/config-link';

export type OutlawCommunityConfig = {
  userId: string;
  groupId?: string;
  title: string;
  name: string;
  menu: HeaderLink[];
  partnerServices?: PartnerServices;
  links?: ConfigLink;
  currentApp?: PartnerApp;
  externalApi?: CommunityExternalApi;
  featureFlags?: Partial<Features>;
  baseUrl?: string;
  gptAppId?: string;
};

export const OUTLAW_COMMUNITY_CONFIG = new InjectionToken<OutlawCommunityConfig>('OUTLAW_COMMUNITY_CONFIG');
